import React from "react";

import CustomDonutChart from "../../common/DataViz/customDonutChart.Component";
import CustomAlertSpeedometer  from '../../common/CustomAlertSpeedo.Component';

import {
  Wrapper,
  Tile,
  Progress,
  Bar,
  ValueWrapper,
} from "./ScoreSummary.styles";

import { zeroPaddedStr, determineAlertLevel, determineFill, alertLevelColor } from "../../common/services";

interface Props {
  scores?: any;
}

function getText(score) {
//   0-25:  URGENT FOCUS NEEDED HERE
// 25-40: YES! KEEP IT UP
// 40-60:  YOU ARE CLIMBING HIGH
// 60-80:  YES! FINAL PUSH TO GENIUS
// 80-100: AMAZING, YOU MADE IT!
  if(score >=0 && score < 25) {
    return "LET'S DO THIS!";
  }else if(score >=25 && score < 40) {
    return 'YES! KEEP IT UP';
  }
  else if(score >= 40 && score < 60) {
    return 'YOU ARE CLIMBING HIGH';
  }
  else if(score >= 60 && score < 80) {
    return 'YES! FINAL PUSH TO GENIUS'
  }
  else if(score >= 80 && score <= 100) {
    return 'AMAZING, YOU MADE IT!'
  }
  else {return 'INVALID'}
}

function ScoreSummary(props: Props) {
  const {scores} = props;

  return (
    <Wrapper>
      <Tile style={{ display: "none" }} width="296px" height="260px">
        <h2 className="tile-label">YOUR CURRENT INTELLECT SCORE</h2>
        <ValueWrapper width="45%">
          <CustomAlertSpeedometer value={scores.average_intellect} />
          <h3 className="value-title">{getText(scores.average_intellect)}</h3>
        </ValueWrapper>
      </Tile>
      <Tile shadow={true} width="480px" height="450px">
        <h2 className="tile-label">YOUR CURRENT PL SCORE</h2>
        <ValueWrapper width="50%">
          <CustomDonutChart
            value={scores.average_weighted}
            color="#ff0033"
            alertLevel={determineAlertLevel(scores.average_weighted)}
            text=""
          />
        </ValueWrapper>

        <ValueWrapper margin="2em 0 0 0" width="80%">
          <h3 className="value-title">PROGRESS MADE SO FAR</h3>
          <Progress>
            <Bar
              value={scores.progress_to_make}
              color={alertLevelColor(
                determineAlertLevel(scores.progress_to_make)
              )}
            />
          </Progress>
        </ValueWrapper>

        <ValueWrapper margin="1em 0 0 0" width="80%">
          <h3 className="value-title">PATHWAYS TO GO</h3>
          <Progress>
            <Bar value={scores.pathways_to_go} color="#3ee9f7" />
          </Progress>
        </ValueWrapper>
      </Tile>
      <Tile style={{ display: "none" }} width="296px" height="260px">
        <h2 className="tile-label">YOUR CURRENT EMOTION SCORE</h2>
        <ValueWrapper width="45%">
          <CustomAlertSpeedometer value={scores.average_emotion} />
          <h3 className="value-title">{getText(scores.average_emotion)}</h3>
        </ValueWrapper>
      </Tile>
    </Wrapper>
  );
}

export default ScoreSummary;



// WEBPACK FOOTER //
// ./src/components/ScoreSummary/ScoreSummary.component.tsx